import React, { Component, createContext } from 'react';
import { initialState, appReducer } from './appReducer';

const AppContext = createContext({
  state: initialState,
  dispatch: () => {},
});

class AppProvider extends Component {
  constructor(props) {
    super(props);

    this.state = {
      appState: initialState,
    };
  }

  dispatch = (action) => {
    this.setState((prevState) => ({
      appState: appReducer(prevState.appState, action),
    }));
  };

  render() {
    return (
      <AppContext.Provider
        value={{
          state: this.state.appState,
          dispatch: this.dispatch,
        }}
      >
        {this.props.children}
      </AppContext.Provider>
    );
  }
}

export { AppContext, AppProvider };